import React, { CSSProperties, useState } from 'react';
import { Col, InputNumber, Row, Slider, } from 'antd';
import ReactEchart from 'echarts-for-react';
import type { EChartsOption,SetOptionOpts } from "echarts";

interface ChartProps{
    options: EChartsOption,
    style?: CSSProperties;
    settings?: SetOptionOpts;
    loading?: boolean;
    theme?: "light" | "dark";
}

const BarChart: React.FC<ChartProps> = ({ options }) => {

    return <ReactEchart option={options} style={{
        height: '100%',
        width: '100%',
      }} />

};

export default BarChart;